import { Loader } from "./hooks/useLoading";

export enum EnumChartAction {
  GROUP_BY = "selectorGroupBy",
  PERIOD = "selectorPeriod",
  GROUP_BY_PERIOD = "SelectorGroupByPeriod",
}

interface IChartProps {
  actions: EnumChartAction[];
}
interface ISelectorTypeProps {
  loading: Loader;
}
export type SelectorTypeFC = React.VFC<ISelectorTypeProps>;
export type ChartFC = React.VFC<IChartProps>;
